import { Box, Button, Tooltip, Typography, useTheme } from "@mui/material";
import { LayoutGroup, motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { MdComputer, MdOutlineDarkMode, MdOutlineLightMode } from "react-icons/md";
import { ThemeMode, useThemeMode } from "../../contexts/themeModeContext";

const MotionDiv = motion.div;

function ThemeSelector() {
    const theme = useTheme();
    const { t } = useTranslation("translation", { keyPrefix: "menu" });
    const { mode, setMode } = useThemeMode();

    const themes = [
        { key: "dark", tooltip: t("theme.dark"), icon: <MdOutlineDarkMode style={{ fontSize: "18px" }} /> },
        { key: "light", tooltip: t("theme.light"), icon: <MdOutlineLightMode style={{ fontSize: "18px" }} /> },
        { key: "system", tooltip: t("theme.system"), icon: <MdComputer style={{ fontSize: "18px" }} /> }
    ];
    return (
        <Box sx={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", alignItems: "center", gap: 2, paddingTop: 1 }}>
            <Typography>{t("theme.theme")}</Typography>
            <LayoutGroup id="theme">
                <Box
                    component={"div"}
                    sx={{
                        position: "relative",
                        display: "flex",
                        gap: "2px",
                        padding: "0.25rem",
                        background: theme.palette.animatedTabBackground,
                        borderRadius: "6px",
                        width: "fit-content"
                    }}
                >
                    {themes.map(currentTheme => {
                        const isActive = mode === currentTheme.key;

                        return (
                            <div key={currentTheme.key} style={{ position: "relative" }}>
                                {isActive && (
                                    <MotionDiv
                                        layoutId="themeTabBg"
                                        transition={{ type: "spring", stiffness: 500, damping: 30 }}
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            borderRadius: "6px",
                                            backgroundColor: theme.palette.animatedTabActiveBackground,
                                            zIndex: 0
                                        }}
                                    />
                                )}
                                <Button
                                    onClick={() => setMode(currentTheme.key as ThemeMode)}
                                    sx={{
                                        position: "relative",
                                        zIndex: 1,
                                        textTransform: "none",
                                        padding: "2px 4px",
                                        minWidth: "32px",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        borderRadius: "6px",
                                        color: isActive ? theme.palette.animatedTabActiveText : theme.palette.animatedTabText,
                                        transition: "color 200ms ease-in-out",
                                        "&:hover": {
                                            backgroundColor: theme.palette.animatedTabHoverBackground,
                                            color: isActive ? theme.palette.animatedTabActiveText : theme.palette.animatedTabText
                                        }
                                    }}
                                >
                                    <Tooltip title={currentTheme.tooltip} placement="top" arrow>
                                        <span style={{ display: "inline-flex", alignItems: "center" }}>{currentTheme.icon}</span>
                                    </Tooltip>
                                </Button>
                            </div>
                        );
                    })}
                </Box>
            </LayoutGroup>
        </Box>
    );
}

export default ThemeSelector;
